interface IBusDetailsPlaceholders {
  companyType: string;
  monthlyIncome: string;
  checkBoxText: string;
  registeredName: string;
  differentRegisterName: string;
  checkBoxText2: string;
  registrationNumber: string;
  industry: string;
}

export function getBusinessDetailsPlaceholders(isThirdParty: boolean): IBusDetailsPlaceholders {
  if (!isThirdParty) {
    return {
      companyType: 'What best describes your business? ',
      monthlyIncome: 'How much money do you process a month?',
      checkBoxText: `I don't know how much I will process monthly`,
      registeredName: `What is your business called? `,
      differentRegisterName: 'Business name',
      checkBoxText2: 'My business is known by a different name',
      registrationNumber: 'Business registration number',
      industry: 'What industry are you in?',
    };
  }

  return {
    companyType: 'What best describes your business? ',
    monthlyIncome: 'How much money do you process a month?',
    checkBoxText: 'Monthly turnover unknown',
    registeredName: 'What is your business called?',
    differentRegisterName: 'Business registration number',
    checkBoxText2: 'The business is known by a different name',
    registrationNumber: 'Business registration number',
    industry: 'business industry',
  };
}

export function uploadDocumentLabelChanges(isThirdParty: boolean) {
  if (isThirdParty) {
    return {
      title: "Upload the customer's documents ",
      subTitle:
        'For us to verify the customer and their business, please upload the following documents',
      bankingSubTitle:
        'A clear copy of their Bank Account Confirmation Letter or Bank statement in PDF or JPEG not older than 3 months.',
    };
  }

  return {
    title: 'Upload your documents ',
    subTitle: 'For us to verify you and your business, please upload the following documents',
    bankingSubTitle:
      'A clear copy of your Bank Account Confirmation Letter or Bank statement not older than 3 months.',
  };
}
